import React, { useState, useEffect, Fragment } from 'react';
import {
  Grid,
  Button,
  Dialog,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Checkbox,
  Toolbar,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import queryString from 'query-string';

import * as api from '../../../services/api/auth';

function FilterBar(props) {
  const {
    updateFilters,
    requestNotifications,
    indicateParamsChanged,
    location,
    history,
    classes: { filterCheckBox },
  } = props;

  //   useEffect(() => {
  //   (async () => {
  //     try {
  //       const user = await api.fetchCurrentUser();
  //       if (user.notificationFilterStatus) {
  //          checked = {
  //           archived: user.notificationFilterStatus.archivedStatus || false,
  //           message:  user.notificationFilterStatus.messageStatus || false,
  //           booking:  user.notificationFilterStatus.bookingStatus || false,
  //           cancellation:  user.notificationFilterStatus.cancelledStatus || false,
  //           request: user.notificationFilterStatus.requestStatus || false,
  //           fromProviders:  user.notificationFilterStatus.fromProviderStatus || false
  //         }
  //       }
        
  //     } catch (err) {
  //       console.log(err);
  //     }
  //   })();
  // }, []);
  
  const parsed = queryString.parse(location.search);
  // let checked;


  const checked = {
    archived: parsed.archived === 'true',
    message: !!(parsed.types && parsed.types.includes('message')),
    booking: !!(parsed.types && parsed.types.includes('booking')),
    cancellation: !!(parsed.types && parsed.types.includes('cancellation')),
    request: !!(parsed.types && parsed.types.includes('request')),
    fromProviders: !!(parsed['from-providers'] === 'true'),
  }

  const [providers, setProviders] = useState([]);
  const [userIsAdmin, setUserIsAdmin] = useState(false);
  const [providerSelectDialogOpen, setProviderSelectDialogOpen] = useState(false);

  const toggleShowingArchived = () => {
    parsed.archived = parsed.archived === 'true' ? 'false' : 'true'
    history.push({ search: queryString.stringify(parsed) })
    requestNotifications('?' + queryString.stringify(parsed))
    indicateParamsChanged()
  }

  const toggleShowingOnlyFromProviders = () => {
    if (parsed['from-providers'] === 'true') delete parsed['from-providers']
    else parsed['from-providers'] = 'true'
    history.push({ search: queryString.stringify(parsed) })
    requestNotifications('?' + queryString.stringify(parsed))
    indicateParamsChanged()
  }

  const toggleShowingType = (type) => {
    parsed.types = parsed.types && parsed.types.includes(type) ? parsed.types.split(',').filter(t => t !== type).join(',') : parsed.types.split(',').concat(type).join(',')
    history.push({ search: queryString.stringify(parsed) })
    requestNotifications('?' + queryString.stringify(parsed))
    indicateParamsChanged()
    props.expandedClose();
  }

  // for each of the following functions "n" is for notification
  const byProviders = providers => n =>
    providers.length === 0 ||
    providers.some(p => p.shown && p.id === n.actionProviderId);

  // grab user and their providers if they're an admin && set our initial filters
  useEffect(() => {
    (async () => {
      let isMount = false;
      try {
        const user = await api.fetchCurrentUser();
        if (user.provider.id) {
          if (isMount) {
          setProviders([
            {
              id: user.provider.id,
              shown: true,
            },
          ]);
        }
        } else if (user.administrator.id) {
          if(!isMount){
          setProviders(
            user.administrator.providers.map(provider => {
              return {
                id: provider.id,
                name: provider.name,
                shown: true,
              };
            })
          );
          }
        
          setUserIsAdmin(true);
        } else {
          throw Error('user is not admin or provider');
        }
        // set our initial filters
        updateFilters([byProviders(providers)], true);
      } catch (err) {
        console.log(err);
        // do better
      }
     return () => {
       isMount = true;
     }
    })();
  }, []);

  const toggleProviderShown = providerId => () => {
    setProviders(
      providers.map(provider => {
        if (providerId === provider.id) provider.shown = !provider.shown;
        return provider;
      })
    );
    // this is lame we turn them all off and then all back on with the new list. there should be a better way.
    updateFilters([byProviders(providers), byProviders(providers)]);
  };

  const ProviderSelectDialog = () => (
    <Dialog
      open={providerSelectDialogOpen}
      onClose={() => setProviderSelectDialogOpen(false)}
    >
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell align="right">Show Notifications</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {providers
            .sort((provider1, provider2) => {
              return provider1.name - provider2.name;
            })
            .map((provider, i) => (
              <TableRow key={i}>
                <TableCell component="th" scope="row">
                  {provider.name}
                </TableCell>
                <TableCell>
                  <Checkbox
                    checked={provider.shown}
                    onChange={toggleProviderShown(provider.id)}
                  />
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </Dialog>
  );

  return (
    <div>
      <Toolbar>
        <Grid container justifyContent="space-between">
          <Grid item sm={2}>
            {userIsAdmin ?
            
              <Button
                onClick={() => setProviderSelectDialogOpen(true)}
                color="primary"
                variant="contained"
                size="small"
              >
                Select Docs
              </Button> :
              <Button
                color="primary"
                variant="contained"
                size="small"
                onClick={toggleShowingOnlyFromProviders}
              >
                <Fragment>
                  <Checkbox
                    className={filterCheckBox}
                    checked={checked.fromProviders}
                  />
                  Only From Docs
                </Fragment>
              </Button>}
              
          </Grid>
          <Grid className="custom-xs-btn-alignment" container item sm={10} justifyContent="flex-end">

            <Button
              color="primary"
              variant="contained"
              size="small"
              onClick={() => toggleShowingType('message')}
            >
              <Fragment>
                <Checkbox
                  className={filterCheckBox}
                  checked={checked.message}
                />
                Messages
              </Fragment>
            </Button>

            <Button
              color="primary"
              variant="contained"
              size="small"
              onClick={() => toggleShowingType('cancellation')}
            >
              <Fragment>
                <Checkbox
                  className={filterCheckBox}
                  checked={checked.cancellation}
                />
                Cancellations
              </Fragment>
            </Button>

            <Button
              color="primary"
              variant="contained"
              size="small"
              onClick={() => toggleShowingType('request')}
            >
              <Fragment>
                <Checkbox
                  className={filterCheckBox}
                  checked={checked.request}
                />
                Requests
              </Fragment>
            </Button>
            
            <Button
              color="primary"
              variant="contained"
              size="small"
              onClick={() => toggleShowingType('booking')}
            >
              <Fragment>
                <Checkbox
                  className={filterCheckBox}
                  checked={checked.booking}
                />
                Bookings
              </Fragment>
            </Button>

            <Button
              color="primary"
              variant="contained"
              size="small"
              onClick={toggleShowingArchived}
            >
              <Fragment>
                <Checkbox
                  className={filterCheckBox}
                  checked={checked.archived}
                />
                Show Archived
              </Fragment>
            </Button>
          </Grid>
        </Grid>
      </Toolbar>
      <ProviderSelectDialog />
    </div>
  );
}

const styles = () => ({
  filterCheckBox: {
    padding: 0,
  },
});

export default withStyles(styles)(FilterBar);
